import React from 'react';
import './styles/App.css';
import { Login } from './login/Login';
import { Route } from 'react-router-dom';
import { HeaderNavBar } from './navBar/HeaderNavBar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalStore } from './utilities/GlobalState';
import { LandingPage } from './landingPage/LandingPage';
import { OrderPage } from './orderPage/OrderPage';
import { MarketingPage } from './marketingPage/MarketingPage';
import { QuotesPage } from './quotesPage/QuotesPage';
import { ManagementPage } from './managementPage/ManagementPage';
import CustomRouter from './utilities/Routing/CustomRouter';
import customHistory from './utilities/Routing/History';
import { isAdmin } from './utilities/Utilites';
import { PasswordReset } from './login/PasswordReset';
import { TechnicalPage } from './technicalPage/TechnicalPage';
import { LeadsPage } from './leadsPage/LeadsPage';
import { LicenseInfo } from '@mui/x-data-grid-pro';

export const App: React.FC = () => {
    LicenseInfo.setLicenseKey(
        '0dd79c876624f25ca73c6df778c476ccTz04NTI2OSxFPTE3NDA3NTIyNDgwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=',
    );
    const globalState = useGlobalStore((state) => state);
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
            <HeaderNavBar />
            <CustomRouter history={customHistory}>
                <Route
                    path="/"
                    element={
                        globalState.authenticated ? <LandingPage /> : <Login />
                    }
                />
                <Route
                    path="/orders"
                    element={
                        globalState.authenticated ? <OrderPage /> : <Login />
                    }
                />
                <Route
                    path="/marketing"
                    element={
                        globalState.authenticated ? (
                            <MarketingPage />
                        ) : (
                            <Login />
                        )
                    }
                />
                <Route
                    path="/technical"
                    element={
                        globalState.authenticated ? (
                            <TechnicalPage />
                        ) : (
                            <Login />
                        )
                    }
                />
                <Route
                    path="/technical"
                    element={
                        globalState.authenticated ? (
                            <TechnicalPage />
                        ) : (
                            <Login />
                        )
                    }
                />
                <Route
                    path="/leads"
                    element={
                        globalState.authenticated ? <LeadsPage /> : <Login />
                    }
                />
                <Route
                    path="/quotes"
                    element={
                        globalState.authenticated ? <QuotesPage /> : <Login />
                    }
                />
                {isAdmin(globalState?.customerRoles || '') ? (
                    <Route
                        path="/management"
                        element={
                            globalState.authenticated ? (
                                <ManagementPage />
                            ) : (
                                <Login />
                            )
                        }
                    />
                ) : (
                    <></>
                )}
                {/* <Route
                    path="/profile"
                    element={<PunchCard /> component={ProfilePage} />}
                /> */}
                {/* <Route path="/public" element={<PublicPage />} /> */}
                {/* <Route path="/callback" element={<CallbackPage />} /> */}
                <Route path="/passwordReset" element={<PasswordReset />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Login />} />
            </CustomRouter>
        </>
    );
};
